var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.value.href}},[_vm._v(_vm._s(_vm.value.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }